import { GetStaticProps } from 'next';

import { getStaticPropsFromStoryblok, Root } from '@/common/storyblok';

export const getStaticProps: GetStaticProps = getStaticPropsFromStoryblok;

export default Root;
